import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

import adTissot from '../../assets/images/ad-tissot.png';
import adSuggested from '../../assets/images/ad-suggested.png';

import Banner from '../common/Banner/Banner';
import AdBanner from '../common/AdBanner/AdBanner';
import TrendingDiv from '../common/TrendingDiv/TrendingDiv';
import ArticleList from '../common/ArticleList/ArticleList';
import OuterBox from '../common/OuterBox/OuterBox';
import InnerBox from '../common/InnerBox/InnerBox';
import SideBar from '../common/SideBar/SideBar';

import BannerLoader from '../common/Loaders/BannerLoader';
import {
  // Title,
  // StyledLine,
  // StyledLineInside,
  ListElement,
  Image
} from '../common/StyledComponents';

class News extends Component {
  componentWillMount = () => {
    // console.log('[News.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('[News.js] CDM');
    this.props.onFetchBanner();
    this.props.onFetchRecentNews(1);
    this.props.onFetchTrendingTags();
    this.props.onFetchTopNews();
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('[News.js] CDUp');
    // Make API requests according to the page that needs to be fetched.
  };

  handlePageChange = page => {
    this.props.onFetchRecentNews(page);
  };

  navigateAndIncreasePostCount = postSlug => {
    // console.log('postId: ', postId);
    // console.log('postSlug: ', postSlug);
    // this.props.onIncreasePostCount(postId);
    this.navigate(postSlug);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    const dataForArticleList = {
      limit: 1,
      pageCount: 8,
      total: 18,
      currentPage: 1
    };
    // console.log('props: ', this.props);
    // console.log('[News.js] render');
    return (
      <div className="News w-100">
        <AdBanner height="250px" width="970px" margin="18px 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {this.props.bannerData ? (
          <Banner bannerData={this.props.bannerData} clicked={this.navigate} />
        ) : (
          <BannerLoader />
        )}

        <TrendingDiv trendingData={this.props.trendingTags} />

        <OuterBox>
          <InnerBox>
            <ArticleList
              className="ArticleList NewsList"
              title="Recent News"
              data={dataForArticleList}
              contentData={this.props.recentNews}
              handlePageChange={this.handlePageChange}
              clicked={this.navigateAndIncreasePostCount}
            />
            <SideBar
              topNewsData={this.props.topNews}
              clicked={this.navigateAndIncreasePostCount}
            />
          </InnerBox>
        </OuterBox>

        <AdBanner height="250px" width="970px" margin="0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        <OuterBox>
          <InnerBox>
            <ListElement className="w-100" maxwidth="100%" padding="20px">
              {/* <Title
                fontFamily="Montserrat"
                fontSize="1.5rem"
                fontWeight="bold"
              >
                Suggested
              </Title>
              <StyledLine>
                <StyledLineInside />
              </StyledLine> */}
              {/* <AdBanner height="210px" width="1000px" margin="0"> */}
              <AdBanner height="346px" width="1040px" margin="0">
                <Image
                  src={adSuggested}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </ListElement>
          </InnerBox>
        </OuterBox>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state: ', state);
  return {
    loading: state.news.loading,
    bannerData: state.news.bannerData,
    recentNews: state.news.recentNews,
    trendingTags: state.news.trendingTags,
    topNews: state.news.topNews
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchBanner: () => dispatch(Creators.fetchBanner()),
  onFetchRecentNews: page => dispatch(Creators.fetchRecentNews(page)),
  onFetchTrendingTags: () => dispatch(Creators.fetchTrendingTags()),
  onFetchTopNews: () => dispatch(Creators.fetchTopNews()),
  onIncreasePostCount: postId => dispatch(Creators.increasePostCount(postId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(News);
